<template>
<div>
    <v-dialog light persistent v-model="stats" class="cardUp">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <table v-if="loaded" style="width: 100%" class="mb-3">
                <tr>
                    <td width="70%" class="cardStatsHeader  pa-1" colspan=2>
                        <strong>{{ configEvento.raceTitle }} - STATISTICHE PASSAGGI</strong><span style="float:right">Num iscritti: {{elencoIscritti.length}} </span>
                    </td>
                </tr>
                <tr v-for="n in listaIntermedi " :key="'titolo'+n">
                    <td width="10%" class="frazioniTitle">{{configEvento['titolo'+n]}}</td>
                    <td width="10%" class="frazioniValue">{{mappaIntermedi[n]}} </td>
                </tr>
            </table>
            <v-btn round class="black  white--text" @click="stats=false">Chiudi</v-btn>
        </v-layout>
    </v-dialog>
    <v-dialog light persistent v-model="filtroDialog" width="340px" scrollable style="max-width:340px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%; width:400px">
            <v-flex v-if="isMultiDivisione()" flex xs12 sm12 md12 lg12 class="mb-4">
                <v-select style="padding: 5px; color: white; color: black" :items="listaDivisioni" v-model="divisioneSelected" :label="'Divisione'" single-line persistent-hint :hint="'Divisione'" @input="changedDivisione"></v-select>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="mb-4">
                <v-select style="padding: 5px; color: white; color: black" :items="listaSesso" v-model="sessoSelected" :label="'Sesso'" single-line persistent-hint :hint="'Sesso'" @input="changedSex"></v-select>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="mb-4">
                <v-select style="padding: 5px; color: white; color: black" :items="listaCategorie" v-model="categoriaSelected" :label="'Categoria'" single-line persistent-hint :hint="'Categoria'" @input="changedCategoria"></v-select>
            </v-flex>
            <v-btn round class="black  white--text" @click="filtroDialog=false">Chiudi</v-btn>
        </v-layout>
    </v-dialog>
    <v-dialog light persistent v-model="settings" class="cardUp" scrollable style="max-width:340px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%; width:400px">
            <table v-if="loaded" style="width: 100%" class="mb-3">
                <tr>
                    <td width="70%" class="cardStatsHeader  pa-1" colspan=2>
                        <strong>Configurazione</strong>
                    </td>
                </tr>
                <tr v-for="key in getConfigKeys() " :key="'config_'+key">
                    <td width="10%" class="frazioniTitle frazioniValueR">{{ key }}</td>
                    <td width="10%" class="">{{configEvento[key]}}</td>
                </tr>
            </table>
            <v-layout align-start row wrap justify-center class="mt-1">
                <v-flex flex xs6 sm6 md6 lg6>
                    <v-btn round class="white  red--text" @click="settings=false">Annulla</v-btn>
                </v-flex>
                <v-flex flex xs6 sm6 md6 lg6>
                    <v-btn round class="white  green--text" @click="salvaConfigurazione()">Salva</v-btn>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-dialog>
    <v-dialog light persistent v-model="addClockDialog" width="500px" scrollable style="max-width:340px;">
        <v-layout align-center column justify-center class="cardStats" style="height:100%; width:400px">
            <table v-if="loaded" style="width: 100%" class="mb-3">
                <tr>
                    <td width="70%" class="cardStatsHeader  pa-1" colspan=2>
                        <strong>Aggiungi orario</strong>
                    </td>
                </tr>
                <tr>
                    <v-text-field style="padding: 3px; color: white; background-color: white" v-model="clockToAdd" label="Inserire orario" outline clearable></v-text-field>
                </tr>
            </table>
            <v-layout align-start row wrap justify-center class="mt-1">
                <v-flex flex xs6 sm6 md6 lg6>
                    <v-btn round class="white  red--text" @click="addClockDialog=false">Annulla</v-btn>
                </v-flex>
                <v-flex flex xs6 sm6 md6 lg6>
                    <v-btn round class="white  green--text" @click="salvaOrario()">Salva</v-btn>
                </v-flex>
            </v-layout>

        </v-layout>
    </v-dialog>
    <v-dialog light persistent v-model="dettaglio" class="cardUp">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <table v-if="currentItem != undefined" style="width: 100%" class="mb-0">
                <tr>
                    <td width="70%" class="cardStatsHeader  pa-1">
                        <strong style="float: left">
                            <span class="mr-2 ml-1 white--text">{{ currentItem.pett }}</span>

                            <country-flag :country="currentItem.nazione !== undefined ? currentItem.nazione : 'it' " size="small" class="" />
                            {{currentItem.cognome }}
                            {{ currentItem.nome }}
                            <br />
                            <span class="ml-4">
                                <small>{{
                                                        currentItem.squadra
                                                    }} </small></span>
                        </strong>
                        <v-icon @click="dettaglio=false" class="ma-0 pa-0 white--text" style="float:right">close</v-icon>
                    </td>
                </tr>
            </table>

            <table v-if="currentItem != undefined" style="width: 100%" class="mb-0">
                <tr>
                    <td width="10%" class="pr-2 frazioniTitle frazioniValueR">Divisione</td>
                    <td width="90%" class="frazioniValue" colspan="2"><strong>{{currentItem.divisione }}</strong></td>
                </tr>
                <tr>
                    <td width="10%" class="pr-2 frazioniTitle frazioniValueR">Pos. Ass.</td>
                    <td width="90%" :class=" color + ' darken-2 frazioniTitleFinale'" colspan="2"><strong>{{currentItem.posAss }}°</strong></td>
                </tr>
                <tr>
                    <td width="10%" class="pr-2 frazioniTitle frazioniValueR">Pos. Cat.</td>
                    <td width="90%" class="frazioniValue " colspan="2"><strong>{{currentItem.posCat }}°</strong> - Cat: {{currentItem.categoria }} </td>
                </tr>
                <tr v-if="isAdmin()">
                    <td width="10%" class="pr-2 frazioniTitle frazioniValueR">Chip</td>
                    <td width="90%" class="frazioniValue " colspan="2">{{currentItem.chip}} </td>
                </tr>
            </table>
            <table v-if="currentItem != undefined" style="width: 100%" class="mb-3">
                <tr>
                    <td class="  pa-1" colspan=3>
                        <strong>Dettaglio PASSAGGI</strong>
                    </td>
                </tr>
                <tr>
                    <td width="10%" colspan="2" class="frazioniTitle">Guntime</td>
                    <td width="10%" colspan="2" class="frazioniValue">{{currentItem.guntime }}</td>
                </tr>

                <tr>
                    <td width="10%" class=""></td>
                    <td width="10%" class="frazioniTitle">Fraz</td>
                    <td width="10%" class="frazioniTitle">Tempo</td>
                    <td width="10%" class="frazioniTitle">Orario</td>
                    <!--td width="10%" class="frazioniValue">{{currentItem['pos'+n]}}</td-->
                </tr>
                <tr v-for="item in currentRilevamenti " :key="'titoloDettaglio'+item.lap">
                    <td width="10%" class="frazioniTitle"><strong>{{item.lap}}</strong></td>
                    <td width="10%" :class="item.warning ? 'red darken-2 frazioniValueR no-wrap white--text' : 'frazioniValue frazioniValueR no-wrap'">{{riduci(item.fraz) }}</td>
                    <td width="10%" class="frazioniValue  frazioniValueR">{{ riduci(item.time)}}</td>
                    <td width="10%" class="frazioniValue frazioniValueR ">{{ item.clock}}<span class="ml-4" v-if="isAdmin()" @click="addClock(item)">
                            <v-icon>add</v-icon>
                        </span></td>
                    <!--td width="10%" class="frazioniValue">{{currentItem['pos'+n]}}</td-->
                </tr>
            </table>
            <v-flex flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                <v-layout align-start row wrap justify-center class="mt-1">
                    <v-btn small round outline class="red--text" @click="annullaFiltro()">Annulla filtro</v-btn>
                    <v-btn small round outline class="green--text" @click="filtroDialog=false">Applica</v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-dialog>
    <v-toolbar app color="black" dark>
        <v-toolbar-title data-cy="titleBtn">
            <img class="menuLogo ml-0 mt-2" src="../assets/images/Logo.png" style="height: 45px" @click="gotoHome()" />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-layout v-if="isDesktopMode()" align-start row justify-center :class=" color + ' darken-2 p-0 m-0'" style="border-radius: 10px 10px 10px 10px"><span class="white--text"><strong>{{ raceTitle }}</strong> | Live results
            </span>
        </v-layout>
        <v-spacer></v-spacer>
        <span class="mr-4">
            <v-icon @click="stats =true">equalizer</v-icon>
        </span>
        <span class="mr-4">
            <v-icon :class="getClasseFiltro()" @click="filtroDialog =true">filter_list</v-icon>
        </span>
        <span class="mr-2">
            <v-icon :class="filterToggle ? 'red--text': ''" @click="toggleSearch()">search</v-icon>
        </span>

        <!--v-icon
                v-if="filterPreferiti"
                class="mr-4 yellow--text"
                @click="togglePreferiti()"
                >star</v-icon
            >
            <v-icon v-else class="mr-4 yellow--text" @click="togglePreferiti()"
                >star_border</v-icon
            -->
        <!--span>
            <v-icon v-if="!compatta" @click="compatta = !compatta">compress</v-icon>
            <v-icon v-else @click="compatta = !compatta">expand</v-icon>
        </span-->
        <!--span>
            <v-icon @click="refreshData()">refresh</v-icon>
        </span-->

    </v-toolbar>
    <v-progress-linear background-color="black" :color="color + ' darken-2'" class="mt-0 p-0 v-toolbar--fixed" v-model="value" :buffer-value="bufferValue"></v-progress-linear>

    <v-layout align-start row wrap justify-center class="mt-1">
        <v-flex v-if="filterToggle" flex xs12 sm6 md6 lg6>
            <v-text-field style="padding: 3px; color: white; background-color: white" v-model="searchText" label="Cerca cognome, team o pettorale" outline clearable append-icon="search" @input="changedSearch"></v-text-field>
        </v-flex>
        <!--v-flex v-if="filterToggle" flex xs12 sm6 md6 lg6 class="mb-4">
            <v-select style="padding: 5px; color: white; color: black" :items="listaCategorie" v-model="categoriaSelected" :label="'Categoria'" single-line persistent-hint :hint="'Categoria'" @input="changedLabel"></v-select>
        </v-flex-->

        <v-flex v-if="isDesktopMode()" flex xs12 sm12 md12 lg12>
            <v-data-table :items="itemsF" hide-actions style="width: 100%;">
                <template v-if="isDesktopMode()" slot="headers" slot-scope="props">
                    <tr class="" style="background-color: #f5f5f5 !important; height:20px">
                        <th v-if="showDivisione" class="black--text text-xs-center">Div</th>
                        <th class="black--text text-xs-center" @click="orderBy('posDiv')">Pos</th>
                        <!--th class="black--text text-xs-center">Pett</th-->
                        <th class="black--text text-xs-center" @click="orderBy('atleta')">Atleta</th>
                        <th v-for="f in fields " :key="'__fieldTitle'+f" class="black--text text-xs-center" @click="orderBy(getFieldName(f))">{{ getFieldName(f) }}</th>
                        <th class="black--text text-xs-center" @click="orderBy('laps')">Giri</th>
                        <th class="black--text text-xs-center" @click="orderBy('lastTime')">Tempo</th>
                        <th class="black--text text-xs-center" @click="orderBy('lastClock')">Orario</th>
                        <th class="black--text text-xs-center" @click="orderBy('min')">Min</th>
                        <th class="black--text text-xs-center" @click="orderBy('max')">Max</th>
                        <th v-for="n in numFrac " :key="'__frazTitle'+n" class="frazioniValue  frazioniValueR no-wrap text-xs-center">{{ - n }}</th>
                    </tr>
                </template>
                <template slot="items" slot-scope="props">
                    <tr v-if="getUltimoPassaggio(props.item) !== undefined" @click="setCurrentItem(props.item)">
                        <td v-if="showDivisione" class="frazioniTitle no-wrap">
                            <strong>{{ props.item.divisione }}</strong>
                        </td>
                        <td v-if="configEvento.criterioClass === undefined" width="5%" class="atleta text-xs-center no-wrap">
                            <strong>{{ props.item.posAss }}</strong>
                        </td>
                        <!--td class="frazioniTitle no-wrap">
                            <strong>{{ props.item.pett }}</strong>
                        </td-->
                        <td width="20%" class="pa-1  black--text frazioniValue text-xs-left" nowrap>
                            <strong>
                                {{ props.item.cognome }} {{ props.item.nome }}
                            </strong>
                        </td>
                        <td v-for="f in fields " :key="'__fieldValue'+f" :class="'black--text frazioniValue no-wrap  text-xs-' + getFieldAlign(f)">{{ getField(props.item, f) }}</td>

                        <td class="grey darken-2 laps no-wrap">
                            <strong>{{ getUltimoPassaggio(props.item) }}</strong>
                        </td>
                        <td :class=" color + ' darken-2 laps no-wrap'">
                            <strong>{{ getUltimoTempo(props.item) }}</strong>
                        </td>
                        <td class="clock no-wrap">
                            <strong>{{ getUltimoOrario(props.item) }}</strong>
                        </td>
                        <td class="no-wrap frazioniValueR">
                            <strong>{{ getMinTempo(props.item) }}</strong>
                        </td>
                        <td class="no-wrap frazioniValueR">
                            <strong>{{ getMaxTempo(props.item) }}</strong>
                        </td>
                        <td :class="isWarningCell(props.item, n) ? 'red darken-2 frazioniValueR no-wrap white--text ' : 'frazioniValueR no-wrap ' + getStyle(props.index)" v-for="n in numFrac " :key="'__frazName'+n">
                            <span>{{ getUltimaFrazione(props.item, n) }}</span>
                        </td>
                    </tr>
                </template>
            </v-data-table>

        </v-flex>

        <v-flex v-else flex xs12 sm12 md12 lg12>
            <v-data-table :items="itemsF" hide-actions hide-headers class="elevation-1 mb-1" style="width: 100%">
                <template slot="items" slot-scope="props">
                    <tr v-if=" getUltimoPassaggio(props.item) !== undefined">
                        <td class="p-0 m-0">
                            <table style="color: black; width: 100%" class="m-0 p-0">
                                <tr class="p-0 m-0">
                                    <td colspan="3" class="cardUp pa-0">
                                        <strong :class="color + ' darken-2 white--text' " style="
                                                    float: left;
                                                    margin: -5px;
                                                    border-radius: 10px 0px 0px
                                                        0px;
                                                    padding: 4px;
                                                    min-width: 30px;
                                                    text-align: center;
                                                ">
                                            {{ props.item.posAss }}
                                        </strong>
                                        <span @click="setCurrentItem(props.item)" class="mt-3" style="
                                                    float: left; margin-left: -30px">
                                            <v-icon class="white--text pa-2">list</v-icon>
                                        </span>

                                        <strong style="float: left">
                                            <span class="mr-2 ml-3 white--text">{{ props.item.pett }}</span>

                                            <country-flag :country="props.item.nazione !== undefined ? props.item.nazione : 'it' " size="small" class="" />
                                            {{ props.item.cognome }}
                                            {{ props.item.nome }}
                                            <br />
                                            <small class="mr-2 ml-3 white--text">{{ props.item.divisione }} ({{ props.item.posAss }}) - {{ props.item.categoria }} ({{ props.item['posCat'] }})</small>

                                            <!--span class="ml-5 white--text">
                                                <small>{{
                                                        props.item.squadra
                                                    }}</small></span-->

                                        </strong>
                                        <div><small class="mr-2 ml-3 white--text" style="float: right">
                                                {{ props.item.lastClock }}
                                            </small></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="frazioniValue">
                                        Passaggi
                                    </td>
                                    <td class="frazioniTitle">
                                        <strong>{{ props.item.laps }}</strong>
                                    </td>
                                    <td :class="color + ' darken-2 white--text frazioniValue' "><strong>{{ getField(props.item, 'metri') }}</strong> mt.</td>

                                </tr>
                                <tr v-if="!compatta">
                                    <td width="33%" :class="isWarningCell(props.item, 1) ? 'red darken-2 frazioniValue  no-wrap white--text ' : ' frazioniValue '">
                                        <span>{{ getUltimaFrazione(props.item, 1) }}</span>
                                    </td>
                                    <td width="33%" :class="isWarningCell(props.item, 2) ? 'red darken-2 frazioniValue  no-wrap white--text ' : ' frazioniValue '">
                                        <span>{{ getUltimaFrazione(props.item, 2) }}</span>
                                    </td>
                                    <td width="33%" :class="isWarningCell(props.item, 3) ? 'red darken-2 frazioniValue  no-wrap white--text ' : ' frazioniValue '">
                                        <span>{{ getUltimaFrazione(props.item, 3) }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>

    </v-layout>
    <v-footer v-if="isAdmin()" fixed class="lightgrey white--text" style="height: 40px; padding: 10px">
        <span v-if="!onlyWarning" class="mr-4">
            <v-icon @click="toggleWarning()">report_problem</v-icon>
        </span>
        <span v-if="onlyWarning" class="mr-4">
            <v-icon @click="toggleWarning()" class="red--text">report_problem</v-icon>
        </span>
        <span class="mr-4">
            <v-icon @click="settings =true">settings</v-icon>
        </span>

        <span v-if="!isMobileMode()" class="black--text ml-4" style="float:right">Refresh data:<strong> {{refreshData/1000}}</strong> sec.<span v-if="indexTo > 0"> | Simulazione dati attiva</span></span>
        <span v-else class="black--text ml-4" style="float:right">{{refreshData/1000}} sec.</span>

        <v-layout align-start row wrap justify-center class="p-0 m-0 black--text">
            <span class="pa-2 ">{{itemsF.length}} righe</span>
        </v-layout>
        <v-icon class="mr-4 black--text" style="float:right" @click="pause = !pause">{{ pause ? 'play_arrow': 'pause'}}</v-icon>
        <span v-if="!isMobileMode()" :class=" pause ? 'red--text mr-4': 'green--text mr-4' " style="float:right"><strong>{{pause ? 'Paused': 'Running'}}</strong></span>
    </v-footer>
    <v-footer v-if="!isAdmin() && filterToggle" fixed class="p-0 grey darken-2" style="height: 30px;">
        <v-layout align-start row wrap justify-center :class=" color + '  darken-2 p-0 m-0 '" style="width:100%; ">
            <v-flex flex xs12 sm12 md12 lg12 class="white pa-2">
                <v-text-field class="white red--text pa-0" style="width:100%;" v-model="searchText" label="Cerca cognome, team o pettorale" outline clearable append-icon="search" @input="changedSearch"></v-text-field>
            </v-flex>
        </v-layout>
    </v-footer>
</div>
</template>

<script>
import helper from '../helper';
import dayjs from 'dayjs'

export default {
    components: {
        //      live: LiveRanking,
    },
    name: 'Live',

    data() {
        return {
            items: [],
            itemsF: [],

            compatta: false,
            categoriaSelected: 'TUTTE',
            sessoSelected: 'TUTTI',
            divisioneSelected: 'TUTTE',
            listaCategorie: ['TUTTE'],
            listaSesso: ['TUTTI', 'MASCHI', 'FEMMINE'],
            filterToggle: false,
            filterPreferiti: false,
            listaPreferiti: {},

            searchText: '',

            raceID: null,
            raceTitle: '',

            connection: null,

            configEvento: {},
            elencoIscritti: [],
            tagFile: null,

            myInterval: null,
            sport: '',

            chipMap: {},
            mappaIntermedi: {},

            currentIndex: 1,
            listaIntermedi: [],

            stats: false,
            loaded: false,
            dettaglio: false,
            currentItem: null,
            currentRilevamenti: {},

            value: 0,
            bufferValue: 100,
            interval: 0,

            mappaDivisioni: {},
            listaDivisioni: [],

            mappaFiles: {},
            clockBatterie: {},

            local: undefined,
            showDivisione: false,
            showBatteria: false,
            showGap: false,
            showFrac: false,
            showTime: true,
            color: 'red',
            numFrac: 1,
            refreshData: 60000,
            refreshPage: 300000,

            showFrazRow: true,
            showTimeRow: true,

            indexTo: -1,
            pause: false,
            fields: [],

            addClockDialog: false,
            clockToAdd: "",
            rilevamentoSelected: undefined,

            settings: false,
            filtroDialog: false,

            warningDelta: 2,
            warningLaps: 5,
            onlyWarning: false,

            orderByField: null,
            direction: true,

            numRilevamentiStep: 0
        };
    },

    beforeCreate() {},

    created() {},

    beforeDestroy() {
        clearInterval(this.myInterval);
        clearInterval(this.myInterval);
    },

    mounted() {
        //console.log(this.$route.params.sport);
        console.log(this.$route.params.raceID);
        this.raceID = this.$route.params.raceID;
        this.paramID = this.$route.params.id;

        this.local = this.$route.params.local;

        //if (this.local != undefined) {
        //  this .local = prompt("Server URL")
        //}
        //this.sport = this.$route.params.sport;

        var pref = helper.ls.get('PREFERITI_' + this.$route.params.raceID);
        console.log('Preferiti:' + JSON.stringify(pref));
        if (pref == undefined) {
            helper.ls.set('PREFERITI_' + this.$route.params.raceID, {});
            this.listaPreferiti = {};
        } else {
            this.listaPreferiti = pref;
        }

        clearInterval(this.myInterval);
        clearInterval(this.myIntervalBar);

        this.loadEvento();
    },

    methods: {

        loadEvento() {
            this.listaIntermedi = [];
            this.elencoIscritti = [];

            console.log(this.raceID);
            const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=remoteLiveConfiguration" + this.raceID + "_" + this.paramID + ".csv";;
            //  if (this.local) _url = "/local/"+ this.raceID+"/localLiveConfiguration" + this.raceID + "_" + this.paramID + ".csv";
            console.log(_url);
            this.getRemoteService(_url).then((response) => {
                console.log(JSON.stringify(response));
                this.configEvento = this.properties2Object(response);

                if (this.local !== undefined) {
                    const toks = this.local.split(",");
                    toks.forEach(tok => {
                        if (tok.indexOf("=") !== -1) {
                            const keyval = tok.split("=");
                            this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                        }
                    })
                }

                if (this.configEvento.gunTime.indexOf(".") == -1) this.configEvento.gunTime += ".000";
                this.configEvento.numSplit = (this.configEvento.numSplit !== undefined) ? parseInt(this.configEvento.numSplit) : 1;

                if (this.configEvento.timeFormat == undefined) this.configEvento.timeFormat = 'HH:mm:ss';
                if (this.configEvento.gapFormat == undefined) this.configEvento.gapFormat = 'HH:mm:ss';

                this.color = this.configEvento.color !== undefined ? this.configEvento.color : 'red';
                this.showGap = (this.configEvento.showGap !== undefined && this.configEvento.showGap == 'true') ? true : false;
                this.showFrac = (this.configEvento.showFrac !== undefined && this.configEvento.showFrac == 'true') ? true : false;
                this.numFrac = (this.configEvento.numFrac !== undefined) ? parseInt(this.configEvento.numFrac) : 1;

                this.showDivisione = (this.configEvento.showDivisione !== undefined && this.configEvento.showDivisione == 'true') ? true : false;
                this.showBatteria = (this.configEvento.showBatteria !== undefined && this.configEvento.showBatteria == 'true') ? true : false;

                this.refreshPage = (this.configEvento.refreshPage !== undefined) ? parseInt(this.configEvento.refreshPage) * 1000 : 300000;
                this.refreshData = (this.configEvento.refreshData !== undefined) ? parseInt(this.configEvento.refreshData) * 1000 : 60000;

                this.indexTo = (this.configEvento.indexTo !== undefined) ? parseInt(this.configEvento.indexTo) : -1

                this.warningDelta = (this.configEvento.warningDelta !== undefined) ? parseFloat(this.configEvento.warningDelta) : 2
                this.warningLaps = (this.configEvento.warningLaps !== undefined) ? parseFloat(this.configEvento.warningLaps) : 5

                this.orderByField = (this.configEvento.orderByField !== undefined) ? this.configEvento.orderByField : null
                this.direction = (this.configEvento.orderByDirection !== undefined) ? (this.configEvento.orderByDirection == 'ASC' ? true : false) : false

                this.compress = (this.configEvento.compress !== undefined && this.configEvento.compress == 'true') ? true : false;
                this.fields = [];
                if (this.configEvento.fields !== undefined) {
                    this.fields = this.configEvento.fields.split(",");
                }

                if (this.configEvento.filtroCategorie !== undefined) {
                    this.listaCategorie = this.configEvento.filtroCategorie.split(",");
                    if (this.listaCategorie.length > 1) this.listaCategorie.unshift("TUTTE");
                }
                if (this.configEvento.filtroDivisioni !== undefined) {
                    this.listaDivisioni = this.configEvento.filtroDivisioni.split(",");
                    if (this.listaDivisioni.length > 1) this.listaDivisioni.unshift("TUTTE");
                }

                if (this.configEvento.batterie !== undefined) {
                    let batterie = this.configEvento.batterie.split(",");
                    batterie.forEach(batt => {
                        console.log("Batteria " + batt + " : " + this.configEvento['batteria' + batt])
                        this.clockBatterie[batt] = this.configEvento['batteria' + batt];
                    })
                } else {
                    console.log("Nessuna batteria")
                }

                this.raceTitle = this.configEvento['raceTitle'];
                for (let index = 1; index <= (this.configEvento.numSplit); index++) {
                    this.listaIntermedi.push(index);
                    this.mappaIntermedi[index] = 0;

                    const split = this.configEvento['split' + index];
                    if (split !== undefined) {
                        const toks = split.split(",");
                        //split3=CONTADINA KM38,tagFileRef=file2,valTime=180,numLap=1
                        this.configEvento['titolo' + index] = toks[0];

                        toks.forEach(tok => {
                            if (tok.indexOf("=") !== -1) {
                                const keyval = tok.split("=");
                                this.configEvento[keyval[0] + index] = this.normalize(keyval[1]);
                            }
                        })
                    }
                    console.log(this.configEvento);

                }

                const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=remoteLiveParticipants" + this.raceID + "_" + this.paramID + ".csv";
                //if (this.local) _url = "/local/"+ this.raceID+ "/localLiveParticipants" + this.raceID + "_" + this.paramID + ".csv";
                this.getRemoteService(_url).then((response) => {
                    this.elencoIscritti = this.csvJSON(response).filter(elem => {
                        let res = true;
                        if (this.configEvento.filtroCategorie) {
                            const found = this.configEvento.filtroCategorie.split(",").find(element => element === elem.categoria);
                            res = found !== undefined;
                        }
                        if (res) {
                            if (this.configEvento.filtroDivisioni) {
                                //console.log("FILTRO DIVISIONI ATTIVO:" + this.configEvento.filtroDivisioni)
                                const found = this.configEvento.filtroDivisioni.split(",").find(element => element === elem.divisione);
                                res = found !== undefined;
                            }
                        }
                        if (this.configEvento.filtroPettorale !== undefined) {
                            const listaPett = this.configEvento.filtroPettorale.split(",");
                            const found = listaPett.find(element => element === elem.pett);
                            res = found !== undefined;
                        }

                        return res
                    });

                    this.mappaDivisioni = {};
                    let mappaCategorie = {};
                    //this.listaDivisioni = [];

                    this.elencoIscritti.forEach(elem => {

                        elem.nazione = 'it';
                        elem.rilevamenti = {};
                        for (let index = 1; index <= (this.configEvento.numSplit); index++) {
                            elem.rilevamenti[index] = [];
                        }

                        if (elem['chip'] != undefined) {
                            if (elem['chip'].indexOf("-") !== -1) {
                                let chips = elem['chip'].split("-");
                                chips.forEach(chip => {
                                    this.chipMap[chip] = elem;
                                })
                            } else {
                                this.chipMap[elem['chip']] = elem;
                            }
                        }

                        this.chipMap[elem['pett']] = elem; // aggiungo anche la possibilità di usare il pettorale come chip

                        if (elem.guntime == undefined || elem.guntime == '') {
                            elem.guntime = this.configEvento.gunTime;

                            if (this.configEvento['gunTime' + elem.divisione] !== undefined && this.configEvento['gunTime' + elem.divisione] !== '') {
                                elem.guntime = this.configEvento['gunTime' + elem.divisione];
                            }

                            if (elem.batteria !== undefined && elem.batteria !== '' && this.clockBatterie[elem.batteria] !== undefined) {
                                elem.guntime = this.clockBatterie[elem.batteria];
                            }
                        }

                        //finishTime6H

                        let mdiv = this.mappaDivisioni[elem['divisione']];
                        if (mdiv === undefined && elem['divisione'] != undefined) {
                            let numLaps = -1;
                            if (this.configEvento['giriDivisione' + elem['divisione']]) {
                                numLaps = parseInt(this.configEvento['giriDivisione' + elem['divisione']]);
                            }

                            this.mappaDivisioni[elem['divisione']] = {
                                id: elem['divisione'],
                                numGiri: numLaps
                            };
                            //this.listaDivisioni.push(elem['divisione']);
                            console.log("Divisione aggiunta: >>" + JSON.stringify(this.mappaDivisioni[elem['divisione']]) + "<<")
                        }

                        mappaCategorie[elem['sesso'] + " - " + elem['categoria']] = elem['categoria'];

                    })
                    //if (this.configEvento.filtroDivisioni === undefined) {
                    this.listaDivisioni = Object.keys(this.mappaDivisioni);
                    if (this.listaDivisioni.length > 1) {
                        this.multiDivisione = true;
                        this.listaDivisioni.unshift("TUTTE");
                    }
                    //   }
                    this.listaDivisioni.sort();

                    this.listaCategorie = Object.keys(mappaCategorie).sort();
                    this.listaCategorie.unshift("TUTTE");

                    this.refresh(this);
                    this.myInterval = setInterval(this.refresh, this.refreshData, this);
                    this.myIntervalBar = setInterval(this.refreshBar, 1000, this);
                    setTimeout(this.refreshAll, this.refreshPage);
                });

            });
        },

        addClock(item) {
            this.clockToAdd = item.clock;
            this.rilevamentoSelected = item;
            this.addClockDialog = true;
        },

        isMultiDivisione() {
            return this.listaDivisioni.length > 1;
        },

        getConfigKeys() {
            return Object.keys(this.configEvento);
        },

        salvaOrario() {
            let _orarioDef = this.clockToAdd;
            /*if (this.clockToAdd.indexOf("+") !== -1 ) {
                const _orario = this.clockToAdd.split("+");
                _orarioDef = _orario[0];
            } else if (this.clockToAdd.indexOf("-") !== -1 ) {
                const _orario = this.clockToAdd.split("-");
                _orarioDef = _orario[0];
            } */

            let _url = this.getTagsURL() + "writeFileTag?idGara=" + this.raceID + "&id=" + this.paramID + "&tag=" + this.currentItem.chip + "&ts=" + _orarioDef + "&op=" + this.timer;
            console.log("EXECUTE UPDATE:" + _url);
            this.writeTag(_url).then(response => {
                console.log(response);
                this.addClockDialog = false;
                this.refresh(this);
            });
        },

        getStyle(index) {
            if (index % 2 == 0) return "grey lighten-4"
            return "white"
        },
        getClasseFiltro() {
            if (this.categoriaSelected !== 'TUTTE' && this.categoriaSelected !== undefined && this.categoriaSelected !== '') {
                return "red--text"
            } else if (this.divisioneSelected !== 'TUTTE' && this.divisioneSelected !== undefined && this.divisioneSelected !== '') {
                return "red--text"
            } else if (this.sessoSelected !== 'TUTTI' && this.sessoSelected !== undefined && this.sessoSelected !== '') {
                return "red--text"
            }
            return ''
        },
        refreshAll() {
            clearInterval(this.myInterval);
            clearInterval(this.myIntervalBar);
            //alert("Riavvio pagina")
            window.location.reload();

        },
        getField(item, key) {
            if (this.getFieldName(key) == 'metri') {
                const numLaps = item.rilevamenti[1].length;
                return numLaps * parseInt(this.configEvento.metriPerGiro);
            }
            return item[this.getFieldName(key)];
        },

        getFieldName(key) {
            if (key.indexOf(":") !== -1) {
                return key.split(":")[0];
            }
            return key;
        },

        getFieldAlign(key) {
            if (key.indexOf(":") !== -1) {
                return key.split(":")[1];
            }
            return 'center';
        },

        getUltimoPassaggio(item, tailNum = 1) {
            if (item && item.rilevamenti && item.rilevamenti[1]) {
                let numLaps = item.rilevamenti[1].length;
                if (tailNum <= numLaps) {
                    return (numLaps - tailNum + 1);
                }
            }
            return undefined;
        },
        getUltimoTempo(item, tailNum = 1) {
            if (item && item.rilevamenti) {
                let numLaps = item.rilevamenti[1].length;
                if (tailNum <= numLaps) {
                    return this.riduci(item.rilevamenti[1][numLaps - tailNum]['time']);
                }
            }
            return undefined;
        },

        getUltimoOrario(item, tailNum = 1) {
            if (item && item.rilevamenti) {
                let numLaps = item.rilevamenti[1].length;
                if (tailNum <= numLaps) {
                    return this.riduci(item.rilevamenti[1][numLaps - tailNum]['clock']);
                }
            }
            return undefined;
        },

        getUltimaFrazione(item, tailNum = 1) {
            if (item && item.rilevamenti) {
                let numLaps = item.rilevamenti[1].length;
                if (tailNum <= numLaps) {
                    return this.riduci(item.rilevamenti[1][numLaps - tailNum]['fraz']);
                }
            }
            return undefined;
        },

        getMinTempo(item) {
            if (item && item.rilevamenti) {
                const listaRil = item.rilevamenti[1];
                if (listaRil.length > 0) {
                    let min = listaRil.reduce(function (prev, curr) {
                        return prev.fraz < curr.fraz ? prev : curr;
                    });
                    return this.riduci(min.fraz);
                }
            }
            return undefined;
        },

        getMaxTempo(item) {
            if (item && item.rilevamenti) {
                const listaRil = item.rilevamenti[1];
                if (listaRil.length > 0) {
                    let min = listaRil.reduce(function (prev, curr) {
                        return prev.fraz > curr.fraz ? prev : curr;
                    });
                    return this.riduci(min.fraz);
                }
            }
            return undefined;
        },

        isWarningCell(item, tailNum = 1) {
            if (item && item.rilevamenti) {
                let numLaps = item.rilevamenti[1].length;
                if (tailNum <= numLaps) {
                    return item.rilevamenti[1][numLaps - tailNum]['warning']
                }
            }
            return undefined;
        },

        isAdmin() {
            return this.configEvento.admin !== undefined;
        },

        orderBy(field) {
            console.log("Order by " + field)

            if (this.orderByField === field) {
                this.direction = !this.direction;
            } else {
                this.direction = true;
                this.orderByField = field;
            }
            this.itemsF = this.filteredList();
        },

        setCurrentItem(item) {
            this.currentItem = item;

            this.currentRilevamenti = [];
            if (item.rilevamenti[1] !== undefined) {
                this.currentRilevamenti = item.rilevamenti[1];
            }
            this.dettaglio = true;
        },
        changedLabel(event) {
            console.log('Changed:' + event);
            this.categoriaSelected = event;

            this.itemsF = this.filteredList();
        },
        changedSex(event) {
            console.log('Changed:' + event);
            this.sessoSelected = event;

            this.itemsF = this.filteredList();
        },

        changedDivisione(event) {
            console.log('Changed:' + event);
            this.divisioneSelected = event;

            this.itemsF = this.filteredList();
        },

        changedCategoria(event) {
            console.log('Changed:' + event);
            this.categoriaSelected = event;

            this.itemsF = this.filteredList();
        },

        changedSearch(event) {
            console.log('Changed:' + event);
            this.searchText = event;

            this.itemsF = this.filteredList();
        },

        annullaFiltro() {
            this.sessoSelected = "TUTTI";
            this.categoriaSelected = "TUTTE";
            this.divisioneSelected = "TUTTE";
            this.filtroDialog = false;
            this.itemsF = this.filteredList();
        },

        isChecked(pett) {
            console.log('is checked');
            return (
                this.listaPreferiti[pett] !== undefined &&
                this.listaPreferiti[pett] == pett
            );
        },

        refresh: function (self) {
            if (this.pause) return;
            self.currentIndex = 1;
            self.value = 0;
            self.numRilevamentiStep = 0;
            self.execute(self);
        },

        refreshBar: function (self) {
            if (this.pause) return;
            if (self.value == undefined) self.value = 0;
            // console.log("refreshBar :" + self.value)
            self.value += (100 / (self.refreshData / 1000));
            //console.log(self.value);
            if (self.value > 100) self.value = 0;
        },

        getTS() {
            return dayjs(new Date()).format('YYYYMMDDHHmmss');
        },

        execute(self) {
            let startFrom = this.mappaFiles[self.currentIndex];
            if (startFrom == undefined) {
                this.mappaFiles[self.currentIndex] = 0;
                startFrom = 0;
            }

            const _url = this.getTagsURL() + "getFileTag?indexFrom=" + startFrom + "&idGara=" + this.raceID + "&id=" + this.paramID + "&ref=" + this.currentIndex + "&indexTo=" + this.indexTo;

            console.log("EXECUTE:" + _url);
            self.getRemoteService(_url).then(
                (response) => {
                    if (response.length > 0) {
                        response = "tag;clock;antenna;progr\n" + response;
                        this.numRilevamentiStep += this.popolaPassaggi(response).length;
                    }
                    console.log("NUM RIL:" + this.numRilevamentiStep)
                    if (self.currentIndex < (self.configEvento.numSplit)) {
                        self.currentIndex++;
                        self.execute(self);
                    } else {
                        this.loaded = true;
                        if (this.numRilevamentiStep > 0) this.showClassifica(self);
                        else console.log("No refresh need")
                    }
                }
            ).catch(
                (error) => {
                    console.log("Errore " + error);
                    self.mappaIntermedi[self.currentIndex] += 0;
                    if (self.currentIndex < (self.configEvento.numSplit)) {
                        self.currentIndex++;
                        self.execute(self);
                    } else {
                        self.loaded = true;
                        if (this.numRilevamentiStep > 0) this.showClassifica(self);
                        else console.log("No refresh need")
                    }
                });

        },

        compareRil(a, b, fieldName, index = 1) {
            if (a.rilevamenti[index].length === b.rilevamenti[index].length) {
                if (a.rilevamenti[index].length == 0) return 0;
                //const tempoA = a.rilevamenti[index][a.rilevamenti[index].length - 1].time;
                //const tempoB = b.rilevamenti[index][b.rilevamenti[index].length - 1].time;

                const tempoA = a[fieldName + index];
                const tempoB = b[fieldName + index];
                //console.log("COMPARE:" +  a.rilevamenti[index].length + " - " + b.rilevamenti[index].length +" - " + tempoA + " " + tempoB);

                if (tempoA === undefined && tempoB == undefined) return 0;
                else if (tempoA === undefined) {
                    return -1
                } else if (tempoB === undefined) {
                    return 1
                }

                if (tempoA < tempoB) {
                    return -1;
                }
                if (tempoA > tempoB) {
                    return 1;
                }
                return 0;
            } else {
                return (b.rilevamenti[index].length - a.rilevamenti[index].length)
            }
        },

        compareField(a, b) {

            let fieldName = this.orderByField;
            if (fieldName == 'atleta') fieldName = 'cognome';

            const molti = this.direction ? 1 : -1;

            let valoreA = a[fieldName];
            let valoreB = b[fieldName];

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (!isNaN(valoreA) && !isNaN(valoreB)) {
                valoreA = parseInt(valoreA);
                valoreB = parseInt(valoreB);
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },

        /* compare(a, b) {
             if (this.configEvento.criterioClass === undefined) {
                 return this.compareRil(a, b, 'tempo');
             } else if (this.configEvento.criterioClass === 'clock') {
                 return this.compareRil(a, b, 'clock');
             } else {
                 return this.compareField(a, b, this.configEvento.criterioClass)
             }
         },*/

        compareClassifica(a, b) {
            return this.compareRil(a, b, 'tempo');
        },

        showClassifica(self) {

             let mappaPosClassifica = {};

            let clockPrimo = null;
            let clockUltimo = null;

            let posAss = 1;
            let posM = 1;
            let posF = 1;

            this.elencoIscritti.sort(this.compareClassifica);
            this.elencoIscritti.forEach(elem => {
                let keyPos = "DIV_" + elem.divisione + "_" + elem.sesso;
                let counterPos = mappaPosClassifica[keyPos];
                if (counterPos == undefined) {
                    mappaPosClassifica[keyPos] = 1;
                } else {
                    mappaPosClassifica[keyPos] = counterPos + 1;
                }
                elem.posDiv = mappaPosClassifica[keyPos];
                 elem.posAss = posAss++;

                if (elem.sesso === 'F') {
                    elem.posMF = posF++;
                } else {
                    elem.posMF = posM++;
                }

                keyPos += "_CAT_" + elem.categoria;
                counterPos = mappaPosClassifica[keyPos];
                if (counterPos == undefined) {
                    mappaPosClassifica[keyPos] = 1;
                } else {
                    mappaPosClassifica[keyPos] = counterPos + 1;
                }
                elem.posCat = mappaPosClassifica[keyPos];

                let indexRil = 0;
                elem.rilevamenti[1].forEach(rilev => {
                    const warn = this.isWarning(elem.rilevamenti[1], rilev, indexRil);
                    rilev.warning = warn;
                    if (warn) elem.warning = true;
                    indexRil++;
                })

                if (this.showGap) {
                    if (clockPrimo == null) {
                        elem.distacco1 = "";
                        elem.distacco2 = "";
                        clockPrimo = elem.tempo;
                    } else {
                        if (elem.tempo > clockPrimo) {
                            elem.distacco1 = this.riduci(this.diffTime(elem.tempo, clockPrimo));
                        } else {
                            elem.distacco1 = "-";
                        }
                        if (elem.tempo >= clockUltimo) {
                            elem.distacco2 = this.riduci(this.diffTime(elem.tempo, clockUltimo));
                        } else {
                            elem.distacco2 = "-";
                        }
                    }
                    clockUltimo = elem.tempo;
                }

            });

            self.items = this.elencoIscritti;
            self.itemsF = this.filteredList();

            // console.log("LISTA:" + JSON.stringify(self.itemsF) );

        },

        isRilevamentoValido(listaRilevamentiAtleta, clock, idPassaggio, laps, guntime, finishTime) {
            const t1 = dayjs(this.normalizzaTS(this.getTime(clock)));
            const tGUN = dayjs(this.normalizzaTS(this.getTime(guntime)));
            if (t1.valueOf() <= tGUN.valueOf()) return false;

            if (finishTime !== undefined && finishTime !== '') {
                const tFinish = dayjs(this.normalizzaTS(this.getTime(finishTime)));
                if (t1.valueOf() > tFinish.valueOf()) return false;
            }

            if (listaRilevamentiAtleta.length == 0) return true;

            if (listaRilevamentiAtleta.length < laps) {
                let valTime = 0;
                if (this.configEvento['valTime' + idPassaggio] !== undefined) {
                    valTime = parseInt(this.configEvento['valTime' + idPassaggio]) * 1000;
                }
                let ultimoPassaggio = this.getTime(listaRilevamentiAtleta[listaRilevamentiAtleta.length - 1].clock);
                //if (ultimoPassaggio.indexOf(".") == -1) ultimoPassaggio += ".000";

                const t0 = dayjs(this.normalizzaTS(ultimoPassaggio)).utc();
                const t1 = dayjs(this.normalizzaTS(this.getTime(clock))).utc();

                //console.log(tempoOrig);
                const diff = t1.valueOf() - t0.valueOf();
                if (diff >= valTime) {
                    return true;
                } else {
                    if (this.configEvento.debug) {
                        console.log("Valtime > " + valTime);
                        console.log(ultimoPassaggio + " > " + t0.valueOf());
                        console.log(this.getTime(clock) + " > " + t1.valueOf());
                        console.log("DIFF:" + diff);
                    }
                }
            } else {
                console.log("Scarto numLap superiori a quelli ammessi nel passaggio  ");
            }
            return false;
        },

        popolaPassaggi(data) {
            let index = this.currentIndex;
            console.log("popolaPassaggi>" + index);

            let lista = this.csvJSON(data);
            console.log("aggiungo >" + lista.length + " letture");
            if (this.configEvento.debug) console.log("aggiungo >" + JSON.stringify(lista));
            this.mappaFiles[index] += lista.length;

            let result = [];

            lista.forEach(elem => {
                if (elem.clock === undefined) {
                    //console.log("Time " + elem.clock + " is before cut: " + cutFrom);
                } else {

                    let laps = 1;
                    if (this.configEvento['numLap' + index] !== undefined) {
                        laps = parseInt(this.configEvento['numLap' + index]);
                    }

                    let p = this.chipMap[elem['tag']];
                    if (p !== undefined) {
                        let pettorale = p['pett'];

                        if (this.mappaDivisioni[p.divisione] !== undefined && this.mappaDivisioni[p.divisione]['numGiri'] > 0) {
                            laps = this.mappaDivisioni[p.divisione]['numGiri']
                        }

                        let _finishTime = p.finishtime;
                        //console.log("FINISH TIME>" + _finishTime + "<")
                        if ((_finishTime === '' || _finishTime == undefined) && this.configEvento['finishTime' + p['divisione']] !== undefined) {
                            _finishTime = this.configEvento['finishTime' + p['divisione']];
                        }

                        if (this.isRilevamentoValido(p.rilevamenti[index], elem.clock, index, laps, p.guntime, _finishTime)) {

                            const _tempo = this.getTempo(p.guntime, elem.clock);
                            const _clock = this.getTime(elem.clock);
                            let _fraz = _tempo;

                            if (p.rilevamenti[index].length > 0) {
                                _fraz = (this.diffTime(_tempo, p.rilevamenti[index][p.rilevamenti[index].length - 1].time));
                            }

                            p.rilevamenti[index].push({
                                pett: p.pett,
                                time: _tempo,
                                clock: _clock,
                                fraz: _fraz,
                                lap: p.rilevamenti[index].length + 1,
                            });

                            if (p.rilevamenti[index].length == laps) {

                                //if (laps > 1 ) console.log("PASSAGGI CORRETTI:" + p.cognome + " " + p.pett)
                                p.clock = this.getTime(elem.clock);
                                p.tempo = this.getTempo(p.guntime, elem.clock)

                                p['tempo' + index] = this.getTempo(p.guntime, elem.clock);
                                p['clock' + index] = this.getTime(elem.clock);
                                p['fraz' + index] = this.getTime(elem.clock);
                            }

                            p.lastClock = _clock;
                            p.lastTime = _tempo;
                            p.laps = p.rilevamenti[index].length;

                            result.push(p);
                        } else {
                            if (this.configEvento.debug) console.log("passaggio non valido:" + elem.tag + " " + p.cognome + " " + elem.clock + " >>" + JSON.stringify(p.rilevamenti[index]));
                        }
                    } else {
                        if (this.configEvento.debug) console.log("Tag " + elem.tag + " sconosciuto");
                    }

                }

            })

            this.mappaIntermedi[index] += result.length;
            return result;

        },

        isWarning(listaRil, rilevamento, indexRil) {
            if (listaRil.length > 1) {
                var utc = require('dayjs/plugin/utc')
                dayjs.extend(utc)

                let ttMin = undefined;
                if (indexRil == 0) return false;

                let indexFrom = indexRil;
                let indexTo = indexFrom + this.warningLaps;

                if (indexRil < this.warningLaps) {
                    indexFrom = 0;
                    indexTo = indexRil;
                } else {
                    indexFrom = indexRil - this.warningLaps;
                    indexTo = indexRil;
                }
                //alert(minVal)

                let last5 = listaRil.slice(indexFrom, indexTo);
                //console.log("da: " + (indexFrom) + " a: " + (indexTo) );

                let min = last5.reduce(function (prev, curr) {
                    //console.log(rilevamento.pett + " >> " + prev.fraz + " - " + curr.fraz);
                    return prev.fraz < curr.fraz ? prev : curr;
                });
                ttMin = min.fraz
                //console.log("WINNER >> " + ttMin)

                const tt0 = this.normalizzaTS(rilevamento.fraz);
                const tt1 = this.normalizzaTS(ttMin);

                const t0 = dayjs(this.getIsoDate(tt0)).utc() + 3600000;
                const tMin = dayjs(this.getIsoDate(tt1)).utc() + 3600000;

                if ((t0.valueOf()) > ((tMin.valueOf()) * this.warningDelta)) {
                    return true;
                }

            }
            return false;
        },

        getTempo(guntime, tempoRil) {
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc);

            const tt0 = this.normalizzaTS(guntime);
            const tt1 = this.normalizzaTS(tempoRil);

            //console.log("getTempo: " + tt0+" "+ tt1);

            const t0 = dayjs(this.getIsoDate(tt0)).utc();
            const t1 = dayjs(this.getIsoDate(tt1)).utc();

            var duration = (t1.diff(t0));
            let result = dayjs(duration).utc().format(this.configEvento.timeFormat);

            //console.log(">getTempo: " +result);

            if (result === 'Invalid Date') return tempoRil;

            return result;
        },

        gotoHome() {
            this.$router.push('/');
        },


        toggleWarning() {
            this.onlyWarning = !this.onlyWarning;
            this.itemF = this.filteredList();
        },

        toggleCompatta() {
            this.compatta = !this.compatta;
        },
        togglePreferiti() {
            this.filterPreferiti = !this.filterPreferiti;
            this.showClassifica(this.raceData);
        },
        toggleItem(pett) {
            if (this.listaPreferiti[pett] == undefined) {
                this.listaPreferiti[pett] = pett;
            } else {
                this.listaPreferiti[pett] = undefined;
            }
            console.log(pett + '-->' + this.listaPreferiti[pett]);
            helper.ls.set(
                'PREFERITI_' + this.$route.params.raceID,
                this.listaPreferiti
            );
            //this.togglePreferiti();
            //this.togglePreferiti();
            //this.showClassifica(this.raceData);
        },

        simpleCompare(a, b) {
            return this.compareField(a, b)
        },

        filteredList() {
            var listaSearch = this.items;
            if (this.searchText !== '' && this.searchText != null) {
                listaSearch = this.items.filter((p) => {
                    let res =
                        p != null &&
                        p.cognome != null &&
                        p.cognome.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;
                    let res1 =
                        p != null &&
                        p.squadra != null &&
                        p.squadra.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    let res2 =
                        p != null &&
                        p.pett != null &&
                        p.pett == this.searchText;

                    let resTot = res || res1 || res2;
                    return resTot;
                });
            }

            //   console.log('categoriaSelected:' + this.categoriaSelected);

            if (this.categoriaSelected !== 'TUTTE') {
                listaSearch = listaSearch.filter((p) => {
                    const _cat = this.categoriaSelected.substring(this.categoriaSelected.indexOf(" - ") + 3);
                    console.log(_cat)
                    var res4 =
                        p != null &&
                        p.categoria != null &&
                        p.categoria == _cat;

                    return res4;
                });
            }

            //        console.log('sessoSelected:' + this.sessoSelected);

            if (this.sessoSelected !== 'TUTTI') {
                listaSearch = listaSearch.filter((p) => {
                    let sex = this.sessoSelected == 'MASCHI' ? 'M' : 'F';
                    var res4 =
                        p != null &&
                        p.sesso != null &&
                        p.sesso == sex;

                    return res4;
                });
            }

            //       console.log('divisioneSelected:' + this.divisioneSelected);

            if (this.divisioneSelected !== 'TUTTE') {
                listaSearch = listaSearch.filter((p) => {
                    var res4 =
                        p != null &&
                        p.divisione != null &&
                        p.divisione == this.divisioneSelected;

                    return res4;
                });
            }

            if (this.orderByField !== null) {
                listaSearch.sort(this.simpleCompare);
            }

            if (this.onlyWarning) {
                listaSearch = listaSearch.filter((p) => {
                    return p.warning;
                })
            }

            if (this.configEvento.filtroRighe) listaSearch = listaSearch.slice(0, parseInt(this.configEvento.filtroRighe));

            return listaSearch;
        },
    },
};
</script>

<style scoped>
td {
    height: 10px !important;
    padding: 5px !important;
    margin: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

.frazioniTitle {
    text-align: center;
    background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}

.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}

.frazioniValueR {
    text-align: right !important;
}

.frazioniTitleFinale {
    text-align: center;
    color: white;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 5px 5px;
    _font-weight: bold;
}

.passaggio {
    background-color: lightgrey;
    text-align: center;
    color: green;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 5px 5px 5px 5px;
    _font-weight: bold;
}

.laps {
    text-align: center;
    color: white;
    font-style: italic;
}

.clock {
    background-color: #212121;
    text-align: center;
    color: white;
    font-style: italic;
}

.cardUp {
    background-color: #212121;
    color: white;
    _border: 1px solid lightgray;
    border-radius: 10px 10px 0px 0px;
}

.atleta {
    background-color: #212121;
    color: white;
}

.cardStatsHeader {
    background-color: #212121;
    color: white;
    border-radius: 10px 10px 0px 0px;
}

.cardStats {
    background-color: white;
    color: black;
    border: 2px solid lightgray;
    border-radius: 10px 10px 10px 10px;
}
</style>
